import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Country, Language } from '@digilize/shared/definitions/src';

@Injectable({
  providedIn: 'root',
})
export class GeolocationApiService {
  constructor(private http: HttpClient) {}

  getUserIp = () => this.http.get('https://geolocation-db.com/json/');

  getCountries = (params?: { include: 'historic' }) => this.http.get<Country[]>('/api/v1.0/countries', { params });
  getLanguages = (params?: { q: string }) => this.http.get<Language[]>('/api/v1.0/languages', { params });
}
